import { render } from "./ConfigInvoiceGuide.vue?vue&type=template&id=73f7ad2a&scoped=true"
import script from "./ConfigInvoiceGuide.vue?vue&type=script&lang=js"
export * from "./ConfigInvoiceGuide.vue?vue&type=script&lang=js"

import "./ConfigInvoiceGuide.vue?vue&type=style&index=0&id=73f7ad2a&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f7ad2a"]])

export default __exports__